import { defineMessages } from '@transcend-io/internationalization';

export const actionButtonMessages = defineMessages(
  'pc-core-components.ActionButton.actionButton',
  {
    twoStep: {
      defaultMessage: 'Step 1 of 2',
    },
  },
);
